<div class="animated fadeIn">
    <div class="col-md-12">

        <div *ngIf="clientConfig">

            <fields-list-component #configurationFieldsListComponent [fields]="fields" name="kiosk_description" [value]="clientConfig"></fields-list-component>

            <button type="button" class="btn btn-outline-primary  pull-right"
                    (click)="save()">Save
            </button>
        </div>
    </div>
</div>